export default defineNuxtRouteMiddleware(to => {
	const config = useAppConfig();
	const auth = useAuth({route: to});
	const authReturn = useAuthReturn({route: to});
	const {getUrlSegments} = useUrl();
	if (!authReturn.enabled || auth.isLoggedIn() || !config.auth.loggedOutRedirect) return;

	const authAction = getUrlSegments(to.path, {ignoreLang: true})[1];
	const publicActions = ['login', 'signup', 'forgotten_password', 'confirm_signup', 'signup_confirm', 'delete_account', 'logout'];
	if (to.meta.contentType === 'auth' && authAction && !publicActions.includes(authAction)) {
		return navigateTo(authReturn.location({destination: to.fullPath, intent: 'protected_page'}));
	}
});
